var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 132,
    viewBox: "0 0 133 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M81.2236 97.806C79.3465 97.806 77.5209 96.8329 76.5132 95.0918C74.4493 91.526 70.6127 89.3109 66.4997 89.3109C62.3878 89.3109 58.5507 91.5255 56.4873 95.0908C54.9834 97.6894 51.6583 98.5765 49.0587 97.0726C46.4601 95.5687 45.573 92.2426 47.0769 89.644C51.0781 82.7318 58.5201 78.4375 66.4997 78.4375C74.4794 78.4375 81.9224 82.7318 85.9236 89.6449C87.4275 92.2436 86.5399 95.5692 83.9413 97.0731C83.0843 97.5703 82.1473 97.806 81.2236 97.806Z",
    fill: "#A6B6C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M90.7775 69.7056C89.6107 69.7056 88.4349 69.3314 87.442 68.559L78.0696 61.2638C76.7461 60.2338 75.9727 58.6508 75.9727 56.9739C75.9727 55.297 76.7466 53.7141 78.0696 52.6841L87.442 45.3889C89.8118 43.5445 93.2274 43.9705 95.0718 46.3398C96.9158 48.7091 96.4902 52.1246 94.1209 53.9691L90.2601 56.9739L94.1209 59.9793C96.4902 61.8232 96.9158 65.2393 95.0718 67.6086C93.9999 68.985 92.3966 69.7056 90.7775 69.7056Z",
    fill: "#A6B6C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.223 69.7061C40.6034 69.7061 39.0007 68.9855 37.9292 67.6086C36.0853 65.2393 36.5108 61.8232 38.8801 59.9793L42.7409 56.9739L38.8801 53.9691C36.5103 52.1251 36.0848 48.7091 37.9287 46.3398C39.7726 43.9705 43.1882 43.5445 45.558 45.3889L54.9309 52.6841C56.2544 53.7141 57.0284 55.2975 57.0284 56.9744C57.0284 58.6513 56.2544 60.2343 54.9314 61.2648L45.5585 68.56C44.5661 69.3319 43.3898 69.7061 42.223 69.7061Z",
    fill: "#A6B6C6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M66.5003 132C30.1073 132 0.5 102.393 0.5 66.0002C0.5 29.6078 30.1073 0 66.5003 0C102.893 0 132.5 29.6073 132.5 66.0002C132.5 102.393 102.893 132 66.5003 132ZM66.5003 10.8729C36.1027 10.8729 11.3729 35.6027 11.3729 66.0002C11.3729 96.3973 36.1027 121.127 66.5003 121.127C96.8973 121.127 121.627 96.3973 121.627 66.0002C121.627 35.6027 96.8973 10.8729 66.5003 10.8729Z",
    fill: "#A6B6C6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.777db9a5ceea1f974f13f8b744ebe85a.svg";
export { ForwardRef as ReactComponent };